import api from "../client.ts";

export type MessageType =  {
  id: number;
  contenu: string;
  objet: string;
  type_destinateur_id: number;
  canal_mail: number;
  canal_sms: number;
  canal_notification: number;
  type_diffusion: "groupe" | "individuel" | string; // adjust if you have fixed values
  status: number;
  created_at: string; // or Date if you parse it
  updated_at: string | null;
}

const getAll = async ():Promise<{size:number, data:MessageType[]}> => {
  const { data } = await api.get("/communique/readAll");
  return data;
};

//SMS messages parents & Personal
const sendSMStoAllParents = async (newMessage:any) => {
  const { data } = await api.post("/communique/sendSMSAllParent", newMessage);
  return data;
};
const sendSMStoParentsByClass = async ( newMessage:any) => {
  const { data } = await api.post("/communique/sendSMSParentClasse", newMessage);
  return data;
};
const sendSMStoOneParent = async (newMessage:any) => {
  console.log("====1====")
  console.log(newMessage)
  const { data } = await api.post("/communique/sendSMSParent", newMessage);
  console.log("====2====")
  console.log(data)
  return data;
};
const sendSMStoAllPersonals = async ( newMessage:any) => {
  const { data } = await api.post("/communique/sendSMSAllPersonnel", newMessage);
  return data;
};
const sendSMStoOnePersonal = async (newMessage:any) => {
  const { data } = await api.post("/communique/sendSMSPersonnel", newMessage);
  return data;
};

//Email  messages parents & Personal
const sendEMAILtoAllParents = async (newMessage:any) => {
  const { data } = await api.post("/communique/sendMailAllParent", newMessage);
  return data;
};
const sendEMAILtoParentsByClass = async ( newMessage:any) => {
  const { data } = await api.post("/communique/sendMailParentClasse", newMessage);
  return data;
};
const sendEMAILtoOneParent = async (newMessage:any) => {
  const { data } = await api.post("/communique/sendMailParent", newMessage);
  return data;
};
const sendEMAILtoAllPersonals = async ( newMessage:any) => {
  const { data } = await api.post("/communique/sendMailAllPersonnel", newMessage);
  return data;
};
const sendEMAILtoOnePersonal = async (newMessage:any) => {
  console.log("email OKK---")
  const { data } = await api.post("/communique/sendMailPersonnel", newMessage);
  return data;
};

const create = async (newMessage:any) => {
  const { data } = await api.post("/communique", newMessage);
  return data;
};
const update = async (id:any, newMessage:any) => {
  const { data } = await api.put(`/communique/${id}`, newMessage);
  return data;
};
const deleteMessage = async (id:any) => {
  const { data } = await api.delete(`/communique/${id}`);
  return data;
};
// const archive = async (id:any) => {
//   const { data } = await api.patch(`/communique/${id}`);
//   return data;
// };
// const send = async (id:any) => {
//   const { data } = await api.patch(`/communique/${id}`);
//   return data;
// };



export const messageControler = {getAll, create, update, deleteMessage,sendSMStoAllParents,sendSMStoParentsByClass,sendSMStoOneParent,sendSMStoAllPersonals,sendSMStoOnePersonal,sendEMAILtoAllParents,sendEMAILtoParentsByClass,sendEMAILtoOneParent,sendEMAILtoAllPersonals,sendEMAILtoOnePersonal}